export class DatosFb {

    public email: string;
    public first_name: string;
    public last_name: string;
    public picture: any;

    constructor(){}
}
